<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>Choose a location</label>
        <small class="form-text text-muted"
          >The location to which the customer(s) will be assigned.</small
        >
        <select
          @change="selectLocation($event)"
          v-model="selectedLocationId"
          class="form-control"
          data-toggle="select"
          data-testid="customer-import-location-select"
        >
          <option selected value="" disabled>Choose one</option>
          <option
            v-for="(location, idx) in userActiveCompanyLocations"
            :key="idx"
            :value="location._id"
          >
            {{ location.friendlyName || location.city || location.name
            }}<span v-if="location.addressDetails">
              ({{ location.addressDetails.streetNumber }}
              {{ location.addressDetails.streetName }})</span
            >
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters, mapActions } from 'vuex'
const userState = createNamespacedHelpers('user').mapState
const companyState = createNamespacedHelpers('company').mapState
export default {
  name: 'CustomerImportLocationDropdown',
  computed: {
    ...companyState(['activeCompany']),
    ...userState(['onlineUser']),
    ...mapGetters('location', ['userActiveCompanyLocations'])
  },
  data: () => ({
    selectedLocationId: ''
  }),
  watch: {
    // The parent form keeps the emitted locationId, which belongs to the previous company after a
    // switch.
    'activeCompany._id'() {
      this.selectedLocationId = ''
      this.$emit('setLocation', undefined)
    },
    userActiveCompanyLocations: {
      immediate: true,
      handler(locations) {
        if (locations.length === 1 && this.selectedLocationId !== locations[0]._id) {
          this.selectLocation({ target: { value: locations[0]._id } })
        }
      }
    }
  },
  methods: {
    ...mapActions('location', ['getUserLocationsByActiveCompany']),
    selectLocation(event) {
      this.selectedLocationId = event.target.value
      this.$emit('setLocation', event.target.value)
    }
  },
  mounted() {
    this.getUserLocationsByActiveCompany()
  }
}
</script>

<style scoped lang="scss"></style>
